import React from 'react'

import './material-activation-column.scss'

import cn from '../../../../commons/src/libs/class-names'
import {mapChildrenWithFragments} from '../../../../commons/src/services/react-children'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import MaterialActivationItem from './material-activation-item'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    title: string
    action?: React.ReactNode
    children: React.ReactNode
    stripe?: boolean
  }
>

const MaterialActivationColumn = ({
  className,
  title,
  action,
  stripe = false,
  children,
  ...props
}: Props) => (
  <div {...props} className={cn('MaterialActivationColumn', {stripe}, className)}>
    <div className="MaterialActivationColumn__header">
      <div className="MaterialActivationColumn__title">{title}</div>
      {action && <div className="MaterialActivationColumn__action">{action}</div>}
    </div>
    {mapChildrenWithFragments<React.ComponentProps<typeof MaterialActivationItem>>(
      children,
      child => React.cloneElement(child, {stripe})
    )}
  </div>
)

export default MaterialActivationColumn
